// 组件版本只允许兼容扩展：新字段必须可选，禁止更改旧字段/枚举/动作语义。
// 破坏性变化须使用新类型。未知必要组件/输入不可忽略后继续执行。
export const COMPONENT_VERSIONS = Object.freeze({text: 1, action_list: 1, device_cards: 1, scene_cards: 1, info_list: 1, task: 1, detail_views: 1})
export function componentSupport(card, versions = COMPONENT_VERSIONS) {
  if (!Object.prototype.hasOwnProperty.call(versions, card.type) || !Number.isSafeInteger(card.version) || card.version < 1) return 'unsupported'
  return card.version > versions[card.type] ? 'partial' : 'supported'
}
